(function adminRoleServiceDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminRoleService', [
            'restUrlBuilder', 'authExtend', 'config', function adminRoleService(restUrlBuilder, authExtend, config) {

                restUrlBuilder = restUrlBuilder('auth');

                var findFilters = {
                    Name: undefined,
                    showNoData: false,
                    organizationalUnitId: authExtend.getOrganizationId(),
                    organizationalUnitName: authExtend.getOrganizationName()
                };

                this.getById = function (id) {
                    var params = { lod: 'Detail' };
                    return restUrlBuilder.one('adminRoles', id)
                                         .get({ params: params });
                };

                this.getNotInUser = function (id, organizationalUnitId) {
                    var params = { NotInUser: id, OrganizationalUnitId: organizationalUnitId, applicationId: config.appId() };
                    return restUrlBuilder.all('adminRoles')
                                         .get({ params: params });
                };

                this.get = function (name, organizationalUnitId, id, applicationId, page, itemsPerPage) {
                    var params = {
                        Name: name
                        , OrganizationalUnitId: organizationalUnitId
                        , Id: id
                        , applicationId: applicationId
                        , Page: page
                        , ItemPerPage: itemsPerPage
                    };
                    return restUrlBuilder.all('adminRoles')
                                         .get({ params: params });
                };

                this.create = function (role) {
                    if (role == null)
                        throw 'documentType no puede ser null';
                    role.applicationId = config.appId();

                    return restUrlBuilder.all('adminRoles')
                                         .post(role);
                };
 
                this.modify = function (role) {
                    if (role == null)
                        throw 'documentType no puede ser null';

                    return restUrlBuilder.all('adminRoles')
                                         .put(role);
                };

                this.clone = function (role) {
                    if (role == null)
                        throw 'documentType no puede ser null';

                    return restUrlBuilder.all('adminRoles/Clone')
                        .put(role);
                };
                this.export = function (name, organizationalUnitId, id, applicationId) {
                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId, Id: id, applicationId: applicationId };
                    return restUrlBuilder.all('adminRoles/Export').put(params);
                };

                this.setFilter = function (filters) {
                    findFilters = filters;
                }

                this.getFilter = function () {
                    return findFilters;
                }

                this.clearFilter = function () {
                     findFilters = {
                        Name: '',
                        showNoData: false,
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()
                     };
                }
            }
        ]);
})();